import {configureStore, createSlice} from '@reduxjs/toolkit';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import {CSSProperties} from "react";

interface StateInterface {
    loading: boolean,
    isMobile:boolean,

}


// initial state
const initialState: StateInterface = {
    loading: true,
    isMobile:window.screen.width < 1024
};

// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
       }
});

// const store = createStore(rootReducer);
const store = configureStore({
    reducer: rootSlice.reducer // reducer: { counter: counterSlice.reducer, auth: authSlice.reducer },
})

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const modalContainerStyle : CSSProperties = {
    zIndex: '1000',
    top:'50%',
    left:'50%',
    boxShadow:'0 0 10px #8a8a8a'
}

